"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnifiedSearchComponent;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _unifiedProductVariant = _interopRequireDefault(require("./unified-product-variant"));
var _rtbTile = _interopRequireDefault(require("../search-components/common/rtb-tile"));
var _imageTile = _interopRequireDefault(require("../search-components/common/image-tile"));
/* eslint-disable no-fallthrough */
/* eslint-disable complexity */
/* LOCAL */

/**
 * Render the product tile.
 * @module ProductTile
 *
 * @param {object} props React props
 * @param {string} props._name tracking name
 * @param {string} props.variant Render variant of the product tile
 * @returns {React.ReactElement} Product tile
 * @public
 */
function UnifiedSearchComponent(props) {
  const {
    variant,
    resultType,
    renderAsHeroTile,
    gridIndex,
    args
  } = props;
  switch (variant) {
    case 'plComponent':
      return /*#__PURE__*/_react.default.createElement(_unifiedProductVariant.default, (0, _extends2.default)({
        renderAsHeroTile: renderAsHeroTile,
        gridIndex: gridIndex,
        actionsLayout: "price-lockup-and-button"
      }, args));
    case 'card':
      if (resultType === 'help') {
        return /*#__PURE__*/_react.default.createElement(_imageTile.default, (0, _extends2.default)({
          tagLabel: args.flagText
        }, args));
      }
      return /*#__PURE__*/_react.default.createElement(_unifiedProductVariant.default, (0, _extends2.default)({
        gridIndex: gridIndex,
        content: {
          Text: args.description
        },
        saleFlagText: args.flagText,
        productName: args.title,
        cta: args?.ctas[0] ?? {},
        actionsLayout: "button",
        featuredImagePortrait: {
          height: 744,
          width: 542,
          altText: 'feature-category-websites@2x',
          url: args.image?.src
        },
        renderAsHeroTile: args.image?.src?.length > 0
      }, args));
    case 'linksList':
      return /*#__PURE__*/_react.default.createElement(_rtbTile.default, {
        tagLabel: resultType.toLowerCase() === 'myaccount' ? 'My Account' : 'help articles',
        heading: resultType.toLowerCase() === 'myaccount' ? null : 'Top Help Results',
        rtbList: args.links,
        ctas: resultType.toLowerCase() === 'myaccount' ? null : args.ctas
      });
    case 'listCard':
      if (resultType === 'product') {
        return /*#__PURE__*/_react.default.createElement(_rtbTile.default, {
          tagLabel: resultType.toLowerCase() === 'myaccount' ? 'My Account' : 'help articles',
          heading: resultType.toLowerCase() === 'myaccount' ? null : 'Top Help Results',
          rtbList: args.links,
          ctas: resultType.toLowerCase() === 'myaccount' ? null : args.ctas
        });
      }
    default:
      return null;
  }
}
UnifiedSearchComponent.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  variant: _propTypes.default.string,
  resultType: _propTypes.default.string,
  args: _propTypes.default.object.isRequired,
  renderAsHeroTile: _propTypes.default.bool,
  gridIndex: _propTypes.default.number
};